import React from "react";
import { MapPin, Phone, Mail, Globe, Clock, Check, Navigation } from "lucide-react";

const Row = ({ icon: Icon, children, testid }) => (
  <div className="flex items-start gap-2.5 text-sm text-[#19324A]/80" data-testid={testid}><Icon className="w-4 h-4 text-[#FF6B9D] shrink-0 mt-0.5" /><span className="min-w-0 break-words">{children}</span></div>
);

export default function PlaceCard({ place }) {
  if (!place?.name) return null;
  const tags = (place.tags || "").split(",").map((t) => t.trim()).filter(Boolean);
  return (
    <aside className="relative rounded-3xl bg-white soft-shadow p-5 sm:p-6 mb-10 overflow-hidden" data-testid="place-card">
      <div className="absolute -right-6 -top-6 w-28 h-28 rounded-full bg-[#FFD93D]/25" aria-hidden="true" />
      <div className="relative flex flex-col sm:flex-row sm:items-start gap-4">
        <span className="w-12 h-12 rounded-2xl bg-[#FF6B9D]/15 flex items-center justify-center shrink-0"><MapPin className="w-6 h-6 text-[#FF6B9D]" /></span>
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h2 className="font-display font-extrabold text-xl text-[#19324A] leading-tight" data-testid="place-name">{place.name}</h2>
            {place.dog_friendly && <span className="inline-flex items-center gap-1 rounded-full bg-[#7ED957]/20 text-[#166534] text-xs font-bold px-2.5 py-1" data-testid="place-dog-friendly"><Check className="w-3.5 h-3.5" /> Dog-friendly</span>}
          </div>
          {tags.length > 0 && <p className="text-xs font-semibold text-[#19324A]/50 mt-1" data-testid="place-tags">{tags.join(" · ")}</p>}
          <div className="grid sm:grid-cols-2 gap-x-6 gap-y-2 mt-4">
            {place.address && <Row icon={Navigation} testid="place-address">{place.address}</Row>}
            {place.hours && <Row icon={Clock} testid="place-hours">{place.hours}</Row>}
            {place.phone && <Row icon={Phone} testid="place-phone"><a href={`tel:${place.phone.replace(/\s+/g, "")}`} className="hover:text-[#FF6B9D]">{place.phone}</a></Row>}
            {place.email && <Row icon={Mail} testid="place-email"><a href={`mailto:${place.email}`} className="hover:text-[#FF6B9D]">{place.email}</a></Row>}
            {place.website && <Row icon={Globe} testid="place-website"><a href={place.website} target="_blank" rel="noopener noreferrer" className="hover:text-[#FF6B9D]">{place.website.replace(/^https?:\/\//, "")}</a></Row>}
          </div>
          {place.map_url && (
            <a href={place.map_url} target="_blank" rel="noopener noreferrer" className="btn-primary !py-2.5 mt-5 inline-flex text-sm" data-testid="place-map-link"><MapPin className="w-4 h-4" /> Open in Google Maps</a>
          )}
        </div>
      </div>
    </aside>
  );
}
